<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <h1 style="float: left;">{{ $root.title}}</h1>
      <div action="#" method="get" class="sidebar-form searchBox" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div class="col-sm-12" style="padding-left: 0px; background-color: #ddd; padding-bottom: 10px; border-radius: 5px;">
          <div class="col-sm-2">
            <span>From Date:</span>
            <input type="date" class="form-control" v-model="filters.fromDate" />
          </div>
          <div class="col-sm-2">
            <span>To Date:</span>
            <input type="date" class="form-control" v-model="filters.toDate" min="filters.toDate" />
          </div>
          <div class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-success" value="Refresh" style="margin-top: 20px;" @click="loadContactsHistory" />
          </div>
        </div>
        <VueTable :isLoading="isLoading" :columns="columns" :rows="filteredItems" @rowClick="rowClick"></VueTable>
      </div>
      <!-- /.table-responsive -->
    </div>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import VAButton from '../components/VAButton'
  import VAAlert from '../components/VAAlert.vue'

  import { db } from '../firebase'
  export default {
    name: 'inbox',
    components: { VueTable, 'va-alert': VAAlert, 'va-button': VAButton },
    data () {
      return {
        isLoading: false,
        contactsHistory: [],
        paginator: null,
        filters: {
          fromDate: '', // 2019-04-10
          toDate: '' // 2019-04-10
        },
        columns: [
          { fieldName: 'Logged', sortFieldName: 'LoggedInt', label: 'Date', isSortable: true, isHidden: false, length: 20, width: '140px' },
          { fieldName: 'FullName', label: 'Full Name', isSortable: true, isHidden: false, width: '160px' },
          { fieldName: 'Email', label: 'Email', isSortable: true, isHidden: false, width: '250px', length: 100 },
          { fieldName: 'Message', label: 'Message', isSortable: true, isHidden: false, isMultiLine: true, length: 1000 },
          // { fieldName: '.key', label: 'Key', isSortable: false, isHidden: false },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'DealerInfo', label: 'Dealer Info', iconClass: 'fa fa-info-circle', color: '#3c8dbc', isLink: true, route: 'Dealer', param: 'DealerKey' },
              { name: 'Delete', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'yelow' }
            ]
          }
        ]
      }
    },
    created () {
      this.$root.title = 'Contact Us'
      this.filters.fromDate = this.$moment().add(-7, 'days').format('YYYY-MM-DD')
      // this.filters.fromDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD')
      this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      /*
      if (this.$root.userHistory) {
        if (this.$root.userHistory.fromDate) {
          this.filters.fromDate = this.$root.userHistory.fromDate
        }
        if (this.$root.userHistory.toDate) {
          this.filters.toDate = this.$root.userHistory.toDate
        }
      } else {
        this.filters.fromDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD')
        this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      }
      */
      this.loadContactsHistory()
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      fromDateInt () {
        // return Number(this.$moment(this.filters.fromDate).format('YYYYMMDDHHmm'))
        return Number(this.$moment(this.filters.fromDate).format('YYYYMMDD') + '0000')
      },
      toDateInt () {
        // return Number(this.$moment(this.filters.toDate).format('YYYYMMDDHHmm'))
        return Number(this.$moment(this.filters.toDate).format('YYYYMMDD') + '2359')
      },
      hasDateRange () {
        return (this.filters.fromDate && this.filters.toDate)
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.contactsHistory.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.contactsHistory
        }
        return result
      }
    },
    methods: {
      rowClick (btn, item) {
        switch (btn) {
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      confirmDelete (item) {
        const vm = this
        console.log(item)
        vm.$bus.$emit('modal-open', {
          title: 'Delete Message',
          description: 'Are you sure you want to delete message from [' + item.FullName + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            console.log(item)
            const contactRef = db.ref('Contact/' + item['.key'])
            contactRef.remove()
            vm.loadContactsHistory()
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      loadContactsHistory () {
        console.log('loadContactsHistory()...')
        const vm = this
        vm.isLoading = true

        vm.$root.userHistory.selectedCustomer = vm.$route.params.customerKey
        vm.$root.userHistory.selectedSite = vm.$route.params.siteKey
        vm.$root.userHistory.fromDate = vm.filters.fromDate
        vm.$root.userHistory.toDate = vm.filters.toDate
        vm.$root.setUserHistory()

        let startAtValue = vm.fromDateInt
        let endAtValue = vm.toDateInt

        console.log(startAtValue)
        console.log(endAtValue)
        let maxLimit = 100
        maxLimit = 5000
        db.ref('Contact').orderByChild('LoggedInt').startAt(startAtValue).endAt(endAtValue).limitToLast(maxLimit).once('value', (snapContactsHistory) => {
        // db.ref('Contact').orderByKey().once('value', (snapContactsHistory) => {
          console.log('Contact Data >>>')
          vm.contactsHistory = []
          const data = snapContactsHistory.val()
          if (data) {
            console.log(data)
            const contactKeys = Object.keys(data)
            console.log('contactKeys.length ::: ' + contactKeys.length)
            for (let i = 0; i < contactKeys.length; i++) {
              let cKey = contactKeys[i]
              let contact = data[cKey]
              contact['.key'] = cKey
              // DealerKey
              // Email
              console.log('contact.DealerKey ::: ' + contact.DealerKey)
              console.log('contact.Email ::: ' + contact.Email)
              if (contact.DealerKey) {
                vm.contactsHistory.push(contact)
              } else {
                db.ref('Users').orderByChild('Email').equalTo(contact.Email).limitToLast(1).once('value', (snapUser) => {
                  const dataUser = snapUser.val()
                  if (dataUser) {
                    const userKeys = Object.keys(dataUser)
                    console.log('userKeys.length ::: ' + userKeys.length)
                    let uKey = userKeys[0]
                    let user = dataUser[uKey]
                    // console.log('User ::: ' + JSON.stringify(dataUser))
                    // DealerUID
                    console.log('user.DealerUID ::: ' + user.DealerUID)
                    contact.DealerKey = user.DealerUID
                    vm.contactsHistory.push(contact)
                  } else {
                    vm.contactsHistory.push(contact)
                  }
                })
              }
            }
            vm.contactsHistory = vm.contactsHistory.slice().sort(function (a, b) {
              return a.LoggedInt > b.LoggedInt ? -1 : 1
            })
            vm.isLoading = false
          } else {
            console.log('contactsHistory NO DATA !!')
            vm.isLoading = false
          }
          vm.isLoading = false
        })
      }
    }
  }
</script>
<style>
  .searchBox {
    border-radius: 3px;
    overflow: hidden;
    text-overflow: clip;
  }

    .searchBox input[type="text"] {
      color: #666;
      border-top-left-radius: 2px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 2px;
    }

    .searchBox .btn {
      color: #999;
      border: 1px solid transparent;
      box-shadow: none;
      border-top-left-radius: 0;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      border-bottom-left-radius: 0;
    }
</style>




// WEBPACK FOOTER //
// Inbox.vue?4faa2e8d